import { useLocation, Navigate } from "react-router-dom";

/**
 * Route wrapper to validate 'tab' param for assessment page.
 * Redirects to '?tab=design' if tab is not one of ['design', 'simulation', 'result'].
 * Usage:
 *   <ValidateAssessmentTab>
 *     <AppRoute ... />
 *   </ValidateAssessmentTab>
 */
export const ValidateAssessmentTab = ({ children }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get("tab")?.toLowerCase();
  const validTabs = ["design", "simulation", "result"];
  if (!validTabs.includes(tab)) {
    params.set("tab", "design");
    return <Navigate to={`${location.pathname}?${params.toString()}`} replace />;
  }
  return children;
};
